import useComputed from '@/hooks/use-computed'
import api from '@/services/api/pitstop.js'
import { useState } from 'react'

const usePitstop = () => {

	const [items, setItems] = useComputed([])

	const [currentItem, setCurrentItem] = useState(null)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState()
	const [allData, setAllData] = useState();

	async function fetch() {
		setLoading(true)


		const [error, data] = await api.index()
		setItems(data)
		setLoading(false)

		if (error) {
			return setError(error )
		}

		if (!Array.isArray(data)) {
			return setError('Pitstop is not an array')
		}
	}

	function view(id) {
		const newCurrentItem = items.find(item => item.id === id)
		setCurrentItem(newCurrentItem)
	}

	return {
		error,
		fetch,
		items,
		currentItem,
		setCurrentItem,
		setItems,
		loading,
		view,
		allData
	}

}

export default usePitstop;
